import $ from 'jquery';
import { GENERAL_INSIGHTS_DATA_TYPES } from '@bingads-webui-campaign-react/competition-core';
import { GENERAL_INSIGHTS_FEATURE_NAMES } from '@bingads-webui-campaign/competition-auction-insight-preferences';

import { getDataSource } from '../general-insights-data-source';
import { getColumnsConfig } from '../general-insights-grid-columns';


export function getConfig({
  customHeaderOffset,
  scope,
  i18n,
  filterService,
  campaignType,
  viewport,
  currentScenario,
  currentActivity,
}) {
  const tableName = i18n.getString('Broad_Insights');
  const dataSource = getDataSource(GENERAL_INSIGHTS_DATA_TYPES.Grid);
  const scrolling = {
    header: {
      type: 'sticky',
      offset: customHeaderOffset || (() => $('nav.navbar-default.navbar-fixed-top').height()),
    },
    virtualized: true,
    attributes: { 'aria-label': i18n.getString('{{tableName}} table header', { tableName }) },
  };

  if (viewport) {
    scrolling.viewport = viewport;
  }

  return {
    name: GENERAL_INSIGHTS_FEATURE_NAMES[campaignType],
    tableClasses: ['table', 'table-bordered'],
    tableAttributes: { 'aria-label': tableName },
    isDataFetchManagerSource: true,
    dataSource,
    filterService,
    rows: {
      headRows: [
        'column-header-rows',
      ],
      bodyRows: [
        {
          type: 'data-rows',
          classes: {
            'auction-insight-column-you': ({ DisplayDomain }) => DisplayDomain === 'You',
          },
        },
      ],
    },
    columns: getColumnsConfig({
      scope,
      campaignType,
    }),
    scrolling,
    currentScenario,
    currentActivity,
    i18n,
  };
}
